import React from 'react';
import './BankSyncModal.css';

// PIN und TAN leben ausschliesslich in diesem lokalen State (nie in x.was,
// nie in localStorage, nie in einer serverseitig gehaltenen Session) und
// werden beim Schliessen explizit geleert. Das optionale "Merken" passiert
// NICHT hier, sondern serverseitig als verschluesselter httpOnly-Cookie
// (PinStore.inc) - dieses Modal sendet dafuer nur das rememberPin-Flag mit
// und erfaehrt nie, wie der gemerkte PIN lautet. fintsState ist der von der
// Bank-Bibliothek gelieferte, undurchsichtige Blob fuer den TAN-Dialog - er
// wird unveraendert an das Backend zurueckgeschickt, aber hier nie
// interpretiert.
export default function BankSyncModal(props) {

	const x = props.x;

	const [pin, setPin] = React.useState('');
	const [remember, setRemember] = React.useState(false);
	const [tanCode, setTanCode] = React.useState('');
	const [fintsState, setFintsState] = React.useState('');
	const [challenge, setChallenge] = React.useState(null);
	const [busy, setBusy] = React.useState(false);
	const [error, setError] = React.useState('');
	const [hint, setHint] = React.useState('');
	// true, solange wir den serverseitig gemerkten PIN verwenden (der Request
	// geht dann mit leerem pin-Feld raus, der Server nimmt den Cookie).
	const [usingStored, setUsingStored] = React.useState(props.pinUse && props.pinStored);

	// Ist ein PIN gemerkt, direkt lossynchronisieren statt erst zu fragen.
	React.useEffect(() => {
		if (props.pinUse && props.pinStored) {
			setBusy(true);
			x.was.axPost('Backend/webapp.php?module=Banking&task=BankingSync', {
				connectionId: props.connectionId,
				pin: '',
			}, handleResult);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function close() {
		setPin('');
		setTanCode('');
		setFintsState('');
		props.onClose();
	}

	function submitPin() {
		if (pin === '') return;
		setBusy(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingSync', {
			connectionId: props.connectionId,
			pin: pin,
			rememberPin: remember ? 1 : 0,
		}, handleResult);
	}

	function submitTan() {
		if (tanCode === '') return;
		setBusy(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingSync', {
			connectionId: props.connectionId,
			pin: pin,
			rememberPin: (pin !== '' && remember) ? 1 : 0,
			tanCode: tanCode,
			fintsState: fintsState,
		}, handleResult);
	}

	function handleResult(result) {
		setBusy(false);
		const content = result.data.content || {};
		if (result.data.returncode !== 1) {
			// Der gemerkte PIN wurde abgelehnt und serverseitig verworfen -
			// zurueckfallen auf manuelle Eingabe statt einer Sackgasse.
			if (content.storedPinCleared) {
				setUsingStored(false);
				setHint('Der gemerkte PIN wurde abgelehnt und verworfen – bitte neu eingeben.');
				setError(content.message || '');
				return;
			}
			if (content.status === 'pin-required') {
				setUsingStored(false);
				return;
			}
			setError(content.message || 'Abruf fehlgeschlagen.');
			return;
		}
		if (content.status === 'tan-required') {
			setChallenge({ text: content.challenge, tanMediumName: content.tanMediumName });
			setFintsState(content.fintsState);
			setTanCode('');
			return;
		}
		setPin('');
		setTanCode('');
		setFintsState('');
		x.wah.addHint(content.transactionCount + ' neue Umsätze abgerufen.');
		props.onSuccess();
	}

	return (
		<div className="banking-sync-overlay">
			<div className="banking-sync-modal">
				<div className="banking-sync-header">
					<span>{props.accountLabel}</span>
					<i className="bi bi-x-lg table-icon" onClick={close}></i>
				</div>
				{challenge === null && usingStored
					?
						<div className="banking-sync-body">
							<p><i className="bi bi-key"></i> Verwende gemerkten PIN…</p>
							{error !== '' && <p className="banking-sync-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
						</div>
					: challenge === null
						?
							<div className="banking-sync-body">
								{hint !== '' && <p className="banking-sync-hint"><i className="bi bi-info-circle"></i> {hint}</p>}
								<label htmlFor="banking-sync-pin">PIN</label>
								<input
									id="banking-sync-pin"
									type="password"
									autoComplete="off"
									value={pin}
									onChange={(e) => setPin(e.target.value)}
									onKeyDown={(e) => { if (e.key === 'Enter') submitPin(); }}
									autoFocus
								/>
								{props.pinUse &&
									<label className="banking-sync-remember">
										<input
											type="checkbox"
											checked={remember}
											onChange={(e) => setRemember(e.target.checked)}
										/>
										PIN merken (verschlüsselt, nur dieser Browser)
									</label>
								}
								{error !== '' && <p className="banking-sync-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
								<button type="button" className="btn" disabled={busy || pin === ''} onClick={submitPin}>
									{busy ? 'Verbinde…' : 'Abrufen'}
								</button>
							</div>
						:
							<div className="banking-sync-body">
								{challenge.text && <p className="banking-sync-challenge">{challenge.text}</p>}
								{challenge.tanMediumName && <p className="banking-sync-medium">Gerät: {challenge.tanMediumName}</p>}
								<label htmlFor="banking-sync-tan">TAN</label>
								<input
									id="banking-sync-tan"
									type="text"
									autoComplete="off"
									value={tanCode}
									onChange={(e) => setTanCode(e.target.value)}
									onKeyDown={(e) => { if (e.key === 'Enter') submitTan(); }}
									autoFocus
								/>
								{error !== '' && <p className="banking-sync-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
								<button type="button" className="btn" disabled={busy || tanCode === ''} onClick={submitTan}>
									{busy ? 'Bestätige…' : 'TAN bestätigen'}
								</button>
							</div>
				}
			</div>
		</div>
	)

};
